import React from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { withRouter } from 'react-router-dom';

const SignUpTransitionGroup = styled(TransitionGroup)`
	box-sizing: border-box;

	.sign-up-view-transition-group,
	.sign-up-content-transition-group {
	}

	.sign-up-view-transition-appear,
	.sign-up-content-transition-appear {
		opacity: 0;
		transition: opacity 300ms;
	}

	.sign-up-view-transition-appear.sign-up-view-transition-appear-active,
	.sign-up-content-transition-appear.sign-up-content-transition-appear-active {
		opacity: 1;
	}

	.sign-up-view-transition-enter,
	.sign-up-content-transition-enter {
		opacity: 0;
	}

	.sign-up-view-transition-enter.sign-up-view-transition-enter-active,
	.sign-up-content-transition-enter.sign-up-content-transition-enter-active {
		opacity: 1;
		transition: opacity 300ms;
	}

	.sign-up-view-transition-exit,
	.sign-up-content-transition-exit {
		opacity: 1;
	}

	.sign-up-view-transition-exit.sign-up-view-transition-exit-active,
	.sign-up-content-transition-exit.sign-up-content-transition-exit-active {
		opacity: 0;
		transition: opacity 0ms;
	}

	.sign-up-view-transition-exit,
	.sign-up-view-transition-exit.sign-up-view-transition-exit-active {
	}

	.pageSlider-exit > .page {
		z-index: 1;
	}

	.pageSlider-enter > .page {
		z-index: 10;
	}

	.pageSlider-enter.left > .page {
		transform: translate3d(10%, 0, 0);
	}

	.pageSlider-enter.right > .page {
		transform: translate3d(-10%, 0, 0);
	}

	.pageSlider-enter.pageSlider-enter-active > .page {
		transform: translate3d(0, 0, 0);
		transition: all 250ms ease-in-out;
	}
`;

export const SignUpTransition = withRouter((props) => {
	const { location, children, history } = props;
	const currentKey = location.pathname.split('/sign-up')[1] || '/';
	const timeout = { enter: 250 };

	return (
		<SignUpTransitionGroup component="div" className="App">
			<CSSTransition
				key={currentKey}
				timeout={timeout}
				exit={false}
				classNames="pageSlider"
			>
				<div className={history.action === 'PUSH' ? 'left' : 'right'}>
					<div className="page-container page">{children}</div>
				</div>
			</CSSTransition>
		</SignUpTransitionGroup>
	);
});

SignUpTransition.propTypes = {
	location: PT.object,
	skipAnimation: PT.bool,
	children: PT.node,
};

export default SignUpTransition;
